module.exports = __webpack_public_path__ + "img/Jun_Yin.89b0720d.png";